import React from "react";
import { formatQty, formatRM } from "@/lib/formatters";
import { shippingLabelFor } from "@/lib/constants";

export const PriceSummary = ({
  productName,
  quantity,
  productAmount,
  shippingAmount,
  country,
  state,
  ready = true,
  testId = "price-summary",
}) => {
  const chosen = Boolean(productName) && ready && productAmount != null;
  const total = Number(productAmount || 0) + Number(shippingAmount || 0);
  if (!chosen) {
    return (
      <div
        className="rounded-2xl border border-[#c79a3b]/30 bg-gradient-to-b from-[#fdf8ec] to-white p-5"
        data-testid={testId}
      >
        <p className="t-label text-[#8a6a1f]">Ringkasan Harga</p>
        <p className="mt-3 t-body text-sm">
          {productName
            ? "Mengira harga…"
            : "Pilih jenis kad (Standard atau Premium) di Bahagian E untuk melihat harga."}
        </p>
      </div>
    );
  }
  return (
    <div
      className="rounded-2xl border border-[#c79a3b]/30 bg-gradient-to-b from-[#fdf8ec] to-white p-5"
      data-testid={testId}
    >
      <p className="t-label text-[#8a6a1f]">Ringkasan Harga</p>
      <dl className="mt-4 space-y-3 text-sm">
        <div className="flex items-baseline justify-between gap-4">
          <dt className="text-[#4a5a53]">
            {productName || "Kad Perniagaan"} — {formatQty(quantity)}
          </dt>
          <dd className="font-semibold text-[#14201b]" data-testid="summary-product-amount">
            {formatRM(productAmount)}
          </dd>
        </div>
        <div className="flex items-baseline justify-between gap-4">
          <dt className="text-[#4a5a53]">{shippingLabelFor(country, state)}</dt>
          <dd className="font-semibold text-[#14201b]" data-testid="summary-shipping-amount">
            {Number(shippingAmount) === 0 ? "Termasuk" : formatRM(shippingAmount)}
          </dd>
        </div>
        <div className="border-t border-[#c79a3b]/25 pt-3 flex items-baseline justify-between gap-4">
          <dt className="font-bold text-[#14201b]">JUMLAH</dt>
          <dd
            className="text-2xl font-extrabold font-heading text-[#0f3f2f]"
            data-testid="summary-total"
          >
            {formatRM(total)}
          </dd>
        </div>
      </dl>
      <p className="mt-4 t-help leading-relaxed">
        Harga termasuk penghantaran ke Semenanjung Malaysia. Tambahan RM10 untuk Sabah, Sarawak
        &amp; W.P. Labuan. Tambahan RM30 untuk Singapura.
      </p>
    </div>
  );
};
